import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import SubPageTemplate from "./templates/SubPageTemplate";
import Hidden from "@material-ui/core/Hidden";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import * as moment from "moment";
import axios from "axios";
import ActionButton from "../components/inputs/ActionButton";
import InfoContainer from "../components/container/InfoContainer";
import { useTranslation, Trans } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import inventoryMissingImg from "../images/inventory_missing.png";
import ribbonMissingImg from "../images/_ribbon-missing.jpg";

import {
  USNNumber,
  ribbonsPageRewardsData,
  ribbonsPageRibbonsData,
  pageHeaderData
} from "./sampleData/sampleData";
import {
  profileAPI,
  headerAPI,
  _link,
  CDN_URI,
  CDN_URI_BASE,
  stripHTML,
  numberWithCommas,
  handleMissingImg,
  prefixURI
} from "../common/utilities";

import styles from "./RibbonsPage.module.scss";

const ribbonImgPath = `${CDN_URI_BASE}web/ribbons/`;
const rewardImgPath = `${CDN_URI_BASE}web/inventory/weapons/300_169/`;

function RibbonsRewardsToggleButton(props) {
  const { showRewards, onClick } = props;
  const { t } = useTranslation();

  return (
    <ActionButton onClick={onClick}>
      {showRewards ? t("See Ribbons") : t("See Rewards")}
    </ActionButton>
  );
}

function RibbonsProgressTracker(props) {
  const {
    onShowRewardsToggleClick,
    showRewards,
    nextTierIndex,
    totalRibbonsTonextTierIndex,
    playerRibbonsTonextTierIndex,
    nextTier,
    nextTierEnd,
    ribbonsCollectedForNextTier
  } = props;

  const theme = useTheme();
  const bpXsDown = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useTranslation();

  const nextTierPercent = Math.round(
    (ribbonsCollectedForNextTier / nextTierEnd) * 100
  );

  // const MyRibbonsProgressTracker = ({ mobile }) => (
  //   <div className={clsx(styles.progress_container, mobile && styles.mobile)}>
  //     <div className={clsx(styles.progress_headings, mobile && styles.mobile)}>
  //       <h3>{`Tier ${nextTier} rewards progress ${ribbonsCollectedForNextTier}/${nextTierEnd} (${nextTierPercent}%)`}</h3>
  //       {!mobile && (
  //         <RibbonsRewardsToggleButton
  //           showRewards={showRewards}
  //           onClick={onShowRewardsToggleClick}
  //         />
  //       )}
  //     </div>
  //     <div className={styles.progress_bar_container}>
  //       <div
  //         className={styles.progress_bar_content}
  //         style={{ width: `${nextTierPercent}%` }}
  //       ></div>
  //     </div>
  //     {mobile && (
  //       <RibbonsRewardsToggleButton
  //         showRewards={showRewards}
  //         onClick={onShowRewardsToggleClick}
  //       />
  //     )}
  //   </div>
  // );

  // return (
  //   <>
  //     {/* desktop */}
  //     <Hidden xsDown>
  //       <MyRibbonsProgressTracker />
  //     </Hidden>
  //     {/* mobile */}
  //     <Hidden smUp>
  //       <MyRibbonsProgressTracker mobile />
  //     </Hidden>
  //   </>
  // );

  return (
    <div className={clsx(styles.progress_container, bpXsDown && styles.mobile)}>
      <div
        className={clsx(styles.progress_headings, bpXsDown && styles.mobile)}
      >
        <h3>
          {t("Tier {{x}} Rewards Progress {{y}}/{{z}} ({{percent}}%)", {
            x: nextTier,
            y: ribbonsCollectedForNextTier,
            z: nextTierEnd,
            percent: nextTierPercent
          })}
        </h3>
        {/* <h3>{`Tier ${nextTier} rewards progress ${ribbonsCollectedForNextTier}/${nextTierEnd} (${nextTierPercent}%)`}</h3> */}
        <Hidden xsDown>
          <RibbonsRewardsToggleButton
            showRewards={showRewards}
            onClick={onShowRewardsToggleClick}
          />
        </Hidden>
      </div>
      <div className={styles.progress_bar_container}>
        <div
          className={styles.progress_bar_content}
          style={{ width: `${nextTierPercent}%` }}
        ></div>
      </div>
      <Hidden smUp>
        <RibbonsRewardsToggleButton
          showRewards={showRewards}
          onClick={onShowRewardsToggleClick}
        />
      </Hidden>
    </div>
  );
}

function RibbonsContainer(props) {
  const { heading, children } = props;

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <InfoContainer
      headerLeft={heading}
      classes={{
        info: clsx(styles.ribbons_container_info, mobile && styles.mobile),
        headerLeft: clsx(styles.ribbons_container_header_left),
        content: styles.ribbons_container_content
      }}
    >
      <Grid container spacing={2}>
        {children}
      </Grid>
    </InfoContainer>
  );
}

function RibbonRewardItem(props) {
  const { data, playerNextTier } = props;

  const { t } = useTranslation();

  let unlockedMessage = "";
  if (data.hasRibbon == 1) {
    const date = window._region === 'BR' ?
      moment(data.achivedDate).format("DD-MM-YYYY") :
      moment(data.achivedDate).format("MM-DD-YYYY");

    unlockedMessage = (
      <>
        <Trans date={date}>
          Unlocked on <strong>{{date}}</strong>
        </Trans>
      </>
    );
  } else if (data.ROWPOS == playerNextTier) {
    unlockedMessage = <>{t("In progress")}</>;
  } else {
    unlockedMessage = <>&nbsp;</>;
  }

  return (
    <Grid item xs={12} sm={6} md={3}>
      <div className={styles.reward_item_container}>
        <div className={styles.reward_item_info}>
          <div className={styles.reward_item_img_container}>
            <img
              className={styles.reward_item_img}
              src={`${rewardImgPath}${data.itemCode}.png`}
              onError={handleMissingImg(inventoryMissingImg)}
            />
          </div>
          <img
            className={styles.reward_item_ribbon_img}
            src={`${ribbonImgPath}${data.imageFileName}`}
            onError={handleMissingImg(`${ribbonMissingImg}`)}
          />
          <h4 className={styles.reward_item_tier}>
            {t("Tier {{x}}", { x: data.ROWPOS })}
          </h4>
          <span className={styles.reward_item_name}>{data.itemName}</span>
          <span className={styles.reward_item_instructions}>
            {stripHTML(data.ribbonDescription)}
          </span>
          <span className={styles.reward_item_unlocked}>{unlockedMessage}</span>
        </div>
      </div>
    </Grid>
  );
}

function RibbonItem({ data }) {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <div
        className={clsx(
          styles.ribbon_item_container,
          !data.hasRibbon && styles.disabled
        )}
      >
        <div className={styles.ribbon_item_info}>
          {data.isTier == 1 && (
            <span className={styles.reward_icon_container}>
              <i className="icon-icon-reward-open" />
            </span>
          )}
          <img
            src={`${ribbonImgPath}${data.imageFileName}`}
            onError={handleMissingImg(`${ribbonMissingImg}`)}
          />
          <h4>{data.ribbonName}</h4>
          <span className={styles.ribbon_desc}>
            {stripHTML(data.ribbonDescription)}
          </span>
        </div>
        <div className={styles.ribbon_item_count}>
          <i className="icon-icon-person" />
          <span>
            {numberWithCommas(data.ribbonCount ? data.ribbonCount : 0)}
          </span>
        </div>
      </div>
    </Grid>
  );
}

function RibbonsPageContent(props) {
  const {
    showRewards,
    onShowRewardsToggleClick,
    ribbonsContent,
    rewardsContent,
    nextTier,
    nextTierEnd,
    ribbonsCollectedForNextTier
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <section className={styles.progress}>
        <RibbonsProgressTracker
          onShowRewardsToggleClick={onShowRewardsToggleClick}
          showRewards={showRewards}
          nextTier={nextTier}
          nextTierEnd={nextTierEnd}
          ribbonsCollectedForNextTier={ribbonsCollectedForNextTier}
        />
      </section>
      <div>
        {!showRewards && <>{ribbonsContent}</>}
        {showRewards && (
          <>
            <section className={styles.rewards}>
              <RibbonsContainer>{rewardsContent}</RibbonsContainer>
            </section>
          </>
        )}
      </div>
      <p className={styles.disclaimer}>
        <Trans>
          Ribbons are updated every 24 hours for active players (logged into the game within 90 days). <br/>Smilegate West reserves the right to modify or remove ribbons at any time without notice.
        </Trans>
      </p>
    </>
  );
}

export default function RibbonsPage(props) {
  const { match, devUSN } = props;

  const [headerData, setHeaderData] = useState(null);
  const [rewardsData, setRewardsData] = useState();
  const [ribbonsData, setRibbonsData] = useState();
  const [showRewards, setShowRewards] = useState(false);
  const [pageStatus, setPageStatus] = useState(true);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useTranslation();

  const usn = devUSN ? devUSN : match ? match.params.usn : null;

  // Similar to componentDidMount and componentDidUpdate:
  //
  // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
  useEffect(() => {
    if (usn) {
      //api call to set data will be used
      axios.get(`${profileAPI}?usn=${usn}&command=ribbontiers`).then(res => {
        setRewardsData(res.data);
      });
      axios
        .get(`${profileAPI}?usn=${usn}&command=ribbons&ribbon=0`)
        .then(res => {
          setRibbonsData(res.data);
        });
      axios.get(`${headerAPI}&usn=${usn}`).then(res => {
        if (res.data.p_o_ErrID === 1)
          setHeaderData(res.data.dsProfileHeaderInfo[0]);
        else setPageStatus(false);
      });
    }
  }, []);

  if (rewardsData == null || ribbonsData == null) {
    return null;
  }

  const onShowRewardsToggleClick = () => {
    setShowRewards(!showRewards);
  };

  let rewardsResult = rewardsData.dsRibbonResult;

  const ribbonsGroup = {};
  let nextTierIndex = 0;
  let nextTierEnd = 0;
  let ribbonsCollectedForNextTier = 0;
  let ribbonsTotal = ribbonsData.dsRibbonTotal[0].ribbonCNT;
  let ribbonsPlayerCount = ribbonsData.dsRibbonTotal[0].playerCNT;
  let ribbonsContent = [];
  let rewardsContent = [];

  for (let item of ribbonsData.dsRibbonGroupListResult) {
    if (!ribbonsGroup.hasOwnProperty(`${item.ribbonType}`)) {
      ribbonsGroup[`${item.ribbonType}`] = {
        name: item.ribbonGroupName,
        ribbons: []
      };
    }
  }
  for (let ribbon of ribbonsData.dsRibbonResult) {

    //console.log('i think the error is here for br')
    //console.log(`${ribbon.ribbonType}`);

    // so I think there is a faulty or incomplete ribbon group

    if(ribbonsGroup[`${ribbon.ribbonType}`] && ribbonsGroup[`${ribbon.ribbonType}`].ribbons){
      ribbonsGroup[`${ribbon.ribbonType}`].ribbons.push(
        <RibbonItem data={ribbon} key={ribbon.ribbonID} />
      );

      //console.log('successfully generated ')
      //console.log(`${ribbon.ribbonType}`);

    }

  }
  for (let group in ribbonsGroup) {
    const ribbonsData = ribbonsGroup[group];
    // const ribbonsArr = ribbonsGroup[group].ribbons;
    if (ribbonsData.ribbons.length > 0) {
      ribbonsData.ribbons.sort((a, b) => {
        //items with no orderID will come first
        const aOrderID = a.props.data.ribbonOption
          ? parseInt(a.props.data.ribbonOption, 10)
          : 0;
        const bOrderID = b.props.data.ribbonOption
          ? parseInt(b.props.data.ribbonOption, 10)
          : 0;

        return aOrderID <= bOrderID ? -1 : 1;
      });

      ribbonsContent.push(
        <section
          key={group}
          className={clsx(styles.ribbons_section, mobile && styles.mobile)}
        >
          <RibbonsContainer heading={ribbonsData.name}>
            {ribbonsData.ribbons}
          </RibbonsContainer>
        </section>
      );
    }
  }
  for (let reward of rewardsResult) {
    rewardsContent.push(
      <RibbonRewardItem data={reward} playerNextTier={nextTierIndex + 1} />
    );

    if (ribbonsPlayerCount > reward.tierEnd) {
      nextTierIndex++;
    }
  }

  if (nextTierIndex !== 0 && !rewardsResult[nextTierIndex]) {
    nextTierEnd =
      rewardsResult[nextTierIndex - 1].tierEnd -
      rewardsResult[nextTierIndex - 1].tierStart +
      1;
    ribbonsCollectedForNextTier = nextTierEnd;

    nextTierIndex--;
  } else {
    nextTierEnd =
      rewardsResult[nextTierIndex].tierEnd -
      rewardsResult[nextTierIndex].tierStart +
      1;
    ribbonsCollectedForNextTier =
      ribbonsPlayerCount - rewardsResult[nextTierIndex].tierStart;
  }

  return (
    <SubPageTemplate
      title={`Ribbons of ${
        headerData ? headerData.NICK : ""
      } - Crossfire Player Profile`}
      headerData={headerData}
      headingLeft={t("Ribbons")}
      headingRight={`${ribbonsPlayerCount}/${ribbonsTotal}`}
    >
      {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
      <RibbonsPageContent
        onShowRewardsToggleClick={onShowRewardsToggleClick}
        showRewards={showRewards}
        ribbonsContent={ribbonsContent}
        rewardsContent={rewardsContent}
        nextTier={nextTierIndex + 1}
        nextTierEnd={nextTierEnd}
        ribbonsCollectedForNextTier={ribbonsCollectedForNextTier}
      />
    </SubPageTemplate>
  );
}
